module.exports = __webpack_public_path__ + "cabbc38b2691033c794b8dfa4bdc0167.png";